import { createFileRoute } from '@tanstack/react-router'
import { BuildsIndexPage } from '../components/pages'
import { CatalogProvider } from '../content/catalog-context'
import { loadPageData } from '../content/page-data-fn'
import { staticRouteHead } from '../lib/seo'

export const Route = createFileRoute('/fr/projets/')({
  loader: () => loadPageData({ data: { kind: 'builds', locale: 'fr' } }),
  head: () => staticRouteHead('builds', 'fr'),
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <CatalogProvider snapshot={Route.useLoaderData().snapshot}>
      <BuildsIndexPage />
    </CatalogProvider>
  )
}
